import { RootRoute, rootRouteData } from '@app/const';
import { Utility } from '@app/utilities/Utility';
import { renderByRoute } from './renderByRoute';

/** Render the root layout/page for @see newRoute & update the URL to match. */
export function navigateToRoute(newRoute: RootRoute) {
  // Panels stay mounted when their route's host is hidden, so close one owned by another route.
  const { panelOwner } = document.getElementById('property_panel')?.dataset ?? {};
  if (panelOwner !== newRoute) {
    Utility.hidePropertyPanel();
  }

  // Set URL.
  const { pathname, search } = window.location;
  const { basePath } = rootRouteData[newRoute] ?? {};
  let newPathname: string;
  if (!basePath) {
    // Hash routes do not use pathname or React Router.
    newPathname = '/app';
  } else {
    newPathname = (pathname.startsWith(basePath)) ? pathname : basePath;
  }
  window.history.pushState(null, '', `${newPathname}${search}#${newRoute}`);

  renderByRoute(newRoute);
}
